import { fromMessageFeedback, type MessagingMessage } from "@/model/messaging";
import { useMemo } from "react";

export const useMessageFeedback = (message?: MessagingMessage) => {
  return useMemo(() => {
    const filtered =
      message?.feedbacks
        ?.map(fromMessageFeedback)
        .filter((feedback) => feedback !== null) ?? [];
    if (filtered.length === 0) {
      return null;
    }
    return filtered[0];
  }, [message]);
};
